//#region [IMPORT]

// === THIRD-PARTY ===
import React, { createContext } from 'react';

// === API ===
import { prokeyAuditQCRemove } from 'api/prokey/prokey.websocket';

// *** MUI / STYLING ***
import { useTheme } from '@mui/material/styles';
import {
  Button,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogContentText,
  DialogActions,
} from '@mui/material';

//#endregion

//-----------------------------------------------------------------
function DeleteAuditQCDialog(props) {
  //-----------------------------------------------------------------

  //#region [VALUES]

  const theme = useTheme();
  const { field } = props;

  //#endregion

  //#region [STYLES]
  const _styles = {
    container: {
    }
  }

  const
  CONTAINER = {
    sx : _styles.container,
  },
  DIALOG = {
    sx : _styles.container,
    open           : props.showDeleteDialog,
    onClose        : handleClose,
    ariaLabelledby : 'form-dialog-title'
  },   
  BUTTON_CLOSE = {
    color    : 'primary'   ,
    onClick  : handleClose ,
    children : [ 'Cancel' ] ,
  },  
  BUTTON_CONFIRM = {
    color    : 'primary'    ,  
    onClick  : handleConfirm ,
    children : [ 'Confirm' ] ,
  }

  //#endregion

  //#region [MODIFY]

  //-----------------------------------------------------------------
  function handleConfirm( event ) {
   //-----------------------------------------------------------------
   prokeyAuditQCRemove(field.Id);
   props.setShowDeleteDialog(false);
  };  

  //-----------------------------------------------------------------
  function handleClose() {
    //-----------------------------------------------------------------
    props.setShowDeleteDialog(false);   
  };

  //#endregion

  //#region [DISPLAY]

  //-----------------------------------------------------------------
  function displayDeleteAuditQCModal() {
    //-----------------------------------------------------------------
    if( !props.showDeleteDialog ) return null;
    return (
      <div { ...CONTAINER } >
        <Dialog { ...DIALOG } >
          <DialogTitle id='form-dialog-title' variant='primary' sx={{ backgroundColor: theme.palette.background.secondary[theme.palette.mode] }}>Delete Entry</DialogTitle>
          <DialogContent sx={{ backgroundColor: theme.palette.background.secondary[theme.palette.mode] }}>
            <DialogContentText> Are you sure you want to permanently delete selected entry?</DialogContentText>         
          </DialogContent>
          <DialogActions sx={{ backgroundColor: theme.palette.background.secondary[theme.palette.mode] }}>
            <Button { ...BUTTON_CLOSE  }/>
            <Button { ...BUTTON_CONFIRM }/>
          </DialogActions>
        </Dialog>      
      </div>
    );
  }

  //#endregion

  return displayDeleteAuditQCModal();

} export {DeleteAuditQCDialog}